<template>
  <div class="content">
    <div class="main-title">
      <p>{{ $t('lang.Renewal Order') }}</p>
    </div>
    <div style="margin-bottom: 40px;"></div>
    <el-form
      :inline="true"
      :model="form"
      class="demo-form-inline mb20"
    >
      <el-form-item :label="$t('lang.Order number')">
        <el-input v-model="form.orderNo" :placeholder="$t('lang.Order number input')" clearable maxlength="50"/>
      </el-form-item>
      <el-form-item :label="$t('lang.Card number')">
        <el-input v-model="form.accountNo" :placeholder="$t('lang.Enter or read the card number')" clearable
                  maxlength="50"
                  @input="form.accountNo = form.accountNo.replace(/[^\d]/g,'')"/>
      </el-form-item>
      <el-form-item :label="$t('lang.Agent/Store')">
        <query-unit-tree @change="handleChange"/>
      </el-form-item>
      <el-form-item :label="$t('lang.Order time')">
        <el-date-picker
          :default-time="['00:00:00', '23:59:59']"
          clearable
          value-format="timestamp"
          v-model="timeArr"
          type="datetimerange"
          range-separator="至"
          :start-placeholder="$t('lang.start time')"
          :end-placeholder="$t('lang.end time')">
        </el-date-picker>
      </el-form-item>
      <el-button type="primary" @click="onsearch">{{ $t('lang.Inquire') }}</el-button>
      <div class="normal-btn ml10" @click="confirmDownloadBtnClick">{{ $t('lang.Export') }}</div>
    </el-form>
    <el-table
      class="mb20"
      :data="tableData"
      style="width: 100%"
    >
      <el-table-column prop="orderNo" :label="$t('lang.Order number')" width="200"></el-table-column>
      <el-table-column prop="createTime" :label="$t('lang.Order time')" width="200">
        <template slot-scope="{row}">
          <div>{{ $changeTime.showTime(row.createTime) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="cardNo" :label="$t('lang.Card number')" width="150"></el-table-column>
      <el-table-column prop="standerds" :label="$t('lang.Product specifications')" width="150"></el-table-column>
      <el-table-column prop="type" :label="$t('lang.Product types')" width="150">
        <template slot-scope="{row}">
          <div v-if="row.commodityTypeCode == 15">{{ $t('lang.Measured card') }}</div>
          <div v-if="row.commodityTypeCode == 4">{{ $t('lang.Timer card') }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="commodityPrice" :label="$t('lang.Commodity price')" width="150">
        <template slot-scope="{row}">
          ฿{{ row.commodityPrice || 0 }}
        </template>
      </el-table-column>
      <el-table-column prop="commodityQuantity" :label="$t('lang.Amount of goods')" width="150"></el-table-column>
      <el-table-column prop="validDays" :label="$t('lang.Effective time')" width="150">
        <template slot-scope="{row}">
          {{ row.validDays || 0 }} {{ $t('lang.day') }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.Available times')" width="150">
        <template slot-scope="{row}">
          {{ row.frequency || '--' }}
          <span v-if="row.frequency">{{ $t('lang.times') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" :label="$t('lang.Username')" width="150"></el-table-column>
      <el-table-column prop="contactInfo" :label="$t('lang.Contact details')" width="150"></el-table-column>
      <el-table-column prop="originalAmount" :label="$t('lang.Amounts payable')" width="150">
        <template slot-scope="{row}">
          ฿{{ row.originalAmount || 0 }}
        </template>
      </el-table-column>
      <el-table-column prop="dealAmount" :label="$t('lang.The amount actually paid')" width="150">
        <template slot-scope="{row}">
          ฿{{ row.dealAmount || 0 }}
        </template>
      </el-table-column>
      <el-table-column prop="payMethod" :label="$t('lang.Payment method')" width="150">
        <template slot-scope="{row}">
          {{ +row.payMethod === 7 ? $t('lang.Online payment') : $t('lang.Offline payment') }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.Operating')" fixed="right" width="150">
        <template slot-scope="{row}">
          <el-button type="primary" @click="checkDetail(row)">{{ $t('lang.Details') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="dfcc">
      <el-pagination
        :current-page="form.beginIndex + 1"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="100"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {thailandOrderManage} from '@/api/orderManagement';

import queryUnitTree from '@/components/common/queryUnitTree';
import {exportExcel} from "../../api/export";

export default {
  data() {
    return {
      //是否正在导出的标志
      isExportFlag: false,
      total: 0,
      timeArr: [],
      unitNo: [],
      form: {
        type: 1,
        businessType: 32,//列表都是0,开卡是31，续费32
        orderNo: '',
        accountNo: '',
        beginTime: '',
        endTime: '',
        status: '',
        primaryDeviceNo: '',
        deviceName: '',
        beginIndex: 0,
        pageSize: 10,
        exportType: 32
      },
      tableData: []
    }
  },
  created() {
    this.$set(this.timeArr, 0, this.$m().set({
      'hour': 0,
      'minute': 0,
      'seconds': 0
    }).valueOf())
    this.$set(this.timeArr, 1, this.$m().set({
      'hour': 23,
      'minute': 59,
      'seconds': 59
    }).valueOf())
    this.onsearch();

  },
  methods: {
    //导出
    confirmDownloadBtnClick() {
      let self = this;
      this.$confirm(this.$t('lang.Whether to confirm export'), "", {
        confirmButtonText: this.$t('lang.Confirm'),
        cancelButtonText: this.$t('lang.Cancel'),
        type: "warning"
      })
        .then(() => {
          self.downloadBtnClick();
        })
        .catch(action => {
        });
    },
    //导出
    async downloadBtnClick() {
      if (this.isExportFlag) {
        this.$message.warning(this.$t('lang.Being exported') + '...')
        return
      }
      let self = this;
      let params = {
        ...this.form
      };
      if (this.unitNo && this.unitNo.length !== 0) {
        params.unitNo = this.unitNo[this.unitNo.length - 1];
      } else {
        params.unitNo = null;
      }
      if (this.timeArr && this.timeArr.length !== 0) {
        params.beginTime = this.$changeTime.sendTime(this.timeArr[0], 'x'),
          params.endTime = this.$changeTime.sendTime(this.timeArr[1], 'x')
      } else {
        params.beginTime = null;
        params.endTime = null;
      }
      try {
        this.isExportFlag = true
        await exportExcel(params)
        this.isExportFlag = false
        this.$message.success(this.$t('lang.Export successful'))
        setTimeout(function () {
          self.$router.push('/managePage/downloadTask')
        }, 1000)
      } catch (e) {
        this.isExportFlag = false
      }
    },
    // select组件
    handleChange(val) {
      this.unitNo = val;
    },
    checkDetail(row) {
      this.$router.push({
        path: '/managePage/batterySwapOrderMgmt',
        query: row
      });
    },
    onsearch() {
      this.form.beginIndex = 0;
      this.thailandOrderManage();
    },
    // 查询
    async thailandOrderManage() {
      const params = {
        ...this.form,
      };
      if (this.unitNo && this.unitNo.length !== 0) {
        params.unitNo = this.unitNo[this.unitNo.length - 1];
      } else {
        params.unitNo = null;
      }
      if (this.timeArr && this.timeArr.length !== 0) {
        params.beginTime = this.$changeTime.sendTime(this.timeArr[0], 'x'),
          params.endTime = this.$changeTime.sendTime(this.timeArr[1], 'x')
      } else {
        params.beginTime = null;
        params.endTime = null;
      }
      try {
        const res = await thailandOrderManage(params);
        this.tableData = res.ldata;
        this.total = res.mdata.total;
      } catch (e) {
        console.log(e);
      }
    },
    handleCurrentChange(page) {
      this.form.beginIndex = page - 1;
      this.thailandOrderManage();
    },
    handleSizeChange(pageSize) {
      this.form.pageSize = pageSize;
    },

  },
  components: {
    queryUnitTree,
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/orderMgmt/chargeCabinetOrderMgmt.vue